<template>
  <el-dialog
    class="radish-dia"
    title="填写淘汰理由"
    top="70px"
    :modal="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="dialogVisible"
  >
    <el-form ref="form" label-width="80px">
      <el-form-item label="淘汰理由"> <el-input v-model="reason" type="textarea"></el-input> </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data: function() {
    return {
      dialogVisible: false,
      reason: '',
      rid: '',
      pid: '',
    }
  },
  methods: {
    show: async function(row, pid) {
      this.rid = row.rid || row._id
      this.pid = pid
      this.dialogVisible = true
    },
    handleConfirm: async function() {
      const res = await app.service('radish').eliminate({ rid: this.rid, pid: this.pid, reason: this.reason })
      if (res.status == 'success') {
        this.$message.success({ duration: 500, message: '淘汰成功' })
        this.onConfirm()
      } else {
        this.$message.error(res.msg)
      }
      this.dialogVisible = false
    },
  },
}
</script>
